import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';

  declare var gtag: Function;
@Component({
  selector: 'app-thankupage',
  templateUrl: './thankupage.component.html',
  styleUrls: ['./thankupage.component.css']
})
export class ThankupageComponent implements OnInit {
 msg: string = '';
infoPromo: any = {}

constructor(private route: ActivatedRoute, private router: Router, private metaService: Meta) { }

 ngOnInit(): void {
    const state = history.state;

    // Validar si viene desde PaKTCambies (estado correcto)
    if (!state || !state.msg) {
      this.router.navigate(['/home']); // Redirigir si no hay mensaje
      return;
    }

    this.msg = state.msg;

    this.metaService.updateTag({ name: 'robots', content: 'noindex' });
    this.enviarConversionGoogleAds();
  }

volver() {
  this.router.navigate(['/PaKTCambies']);
}

enviarConversionGoogleAds() {
  // Asegúrate de que gtag esté definido
  if (typeof gtag !== 'undefined') {
    gtag('event', 'conversion', {
      'send_to': 'AW-16731844654/9DhpCNC0s94aEK7grqo-',
      'value': 1.0,
      'currency': 'MXN'
    });
  } else {
    console.warn('gtag no está definido. Verifica que el tag global esté cargado.');
  }
}

}
